export default class NewUserPopup {
    constructor() {
        this.popupShown = false;
        this.popupKey = 'hadran_new_user_popup_shown';
        this.hidePopupKey = 'hadran_hide_new_user_popup';
        this.addEvents();
    }

    addEvents() {
        // Check if user is logged in and is a new user (data will be passed from PHP)
        if (typeof hadranNewUserData !== 'undefined' && hadranNewUserData.isNewUser) {
            // Set timeout to show popup after 15 seconds
            setTimeout(() => {
                this.showPopup();
            }, 15000); // 15 seconds
        }

        // Close popup events
        document.addEventListener('click', (e) => {
            if (e.target.matches('.new-user-popup__close, .new-user-popup__rgba, .new-user-popup__button')) {
                this.closePopup();
            }
        });

        // Handle checkbox for not showing popup again
        const hidePopupCheckbox = document.getElementById('hide-new-user-popup');
        if (hidePopupCheckbox) {
            hidePopupCheckbox.addEventListener('change', (e) => {
                if (e.target.checked) {
                    localStorage.setItem(this.hidePopupKey, 'true');
                }
            });
        }
    }

    showPopup() {
        // Check if popup was already shown in this session
        if (this.wasPopupShown()) {
            return;
        }

        const popup = document.querySelector('.new-user-popup');
        if (popup) {
            popup.classList.add('open');
            this.popupShown = true;
            this.setPopupShown();
        }
    }

    closePopup() {
        const popup = document.querySelector('.new-user-popup');
        if (popup) {
            popup.classList.remove('open');
        }
    }

    // Check if popup was already shown in this session or user opted to hide it permanently
    wasPopupShown() {
        // Check if user opted to hide popup permanently
        if (localStorage.getItem(this.hidePopupKey) === 'true') {
            return true;
        }
        // Check if popup was shown in this session
        return sessionStorage.getItem(this.popupKey) === 'true';
    }

    // Mark popup as shown for this session
    setPopupShown() {
        sessionStorage.setItem(this.popupKey, 'true');
    }
}
